import { MarketplaceStoreInstallationTargetProduct } from '@atlassian/mpac-types/graphql-gateway-types';
import { foldMarketplaceProduct } from '../types/MarketplaceProduct';
export default product => foldMarketplaceProduct(product)(() => 'Jira', () => 'Confluence', () => 'Compass');
export const ProductNameToTargetProductMap = {
  confluence: MarketplaceStoreInstallationTargetProduct.Confluence,
  jira: MarketplaceStoreInstallationTargetProduct.Jira,
  compass: MarketplaceStoreInstallationTargetProduct.Compass
};